export class RegistrationModel {
    EmailAddress = '';
    Password = '';
    Token = '';
    VerificationPassword = '';
    Dob: string;
  }



// WEBPACK FOOTER //
// ./src/app/models/registration-model.ts